// extracted by mini-css-extract-plugin
export default {"searchContainer":"search_searchContainer__gya31"};